/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useEffect, useState, useRef } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "../../../component/button";
import classes from "./order.module.css";
import DialogContent from "@mui/material/DialogContent";
import Input from "../../../component/inputpm";
import Loader from "../../../component/loader";
import BusApiCall from "../../../helper/axios";
import constants from "../../../helper/constants";
import { withTranslation } from "react-i18next";
import GenericBPMNForm from "../../../component/genericBPMNForm/genericBPMNForm";
import { Grid } from "@mui/material";
import bpmnFormValidator from "../../../helper/bpmnFormValidator";
import { connect } from "react-redux";
import actionTypes from "../../../store/actions";
import Draggable from "react-draggable";
import { Paper, Tooltip, IconButton, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Collapse,
} from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import jp from "jsonpath";
import TableContainer from "@mui/material/TableContainer";
// import { makeStyles } from '@mui/styles';

// Get order props from parent (View Order page)
const PartialOrderProcessingDialog = (props) => {
  console.log("check all props", props);
  const t = props.t;
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [error, setError] = useState("");
  // const useStyles = makeStyles({
  //     resizablePaper: {
  //         resize: 'both',
  //         overflow: 'auto',
  //         minWidth: 640,
  //         minHeight: 200,
  //         maxWidth: '90vw',
  //         maxHeight: '90vh',
  //         width: '60vw',
  //     }
  // });
  // const classess = useStyles();
  useEffect(() => {
    setTableData(JSON.parse(props.data));
  }, []);
  const submitForm = () => {
    var tempTableData = [...tableData];
    console.log("check table data", tempTableData);
    var payload = {
      packageIds: [],
    };
    for (var i = 0; i < tempTableData.length; i++) {
      if (tempTableData[i].quantity && tempTableData[i].quantity > 0) {
        var item = {
          packageId: tempTableData[i].packageId,
          quantity: +tempTableData[i].quantity,
          // identifiersValue: []
        };
        // for (var j = 0; j < tempTableData[i].identifiersDetail.length; j++) {
        //     if (tempTableData[i].identifiersDetail[j].packageIndex) { } else {
        //         for (var k = 0; k < tempTableData[i].identifiersDetail[j].identifiers.length; k++) {
        //             // if (tempTableData[i].identifiersDetail[j].identifiers[k].value) { } else {
        //             //     setError(tempTableData[i].identifiersDetail[j].identifiers[k].label + ' ' + props.t('IS_REQUIRED'));
        //             //     return;
        //             // }
        //             // var duplicateValues = jp.query(tempTableData[i].identifiersDetail, '$..[?(@.value=="' + tempTableData[i].identifiersDetail[j].identifiers[k].value + '" && @.name=="' + tempTableData[i].identifiersDetail[j].identifiers[k].name + '")]');
        //             // if (duplicateValues.length > 1) {
        //             //     setError(props.t('DUPLICATE') + ' ' + tempTableData[i].identifiersDetail[j].identifiers[k].label + ' ' + props.t('FOUND'));
        //             //     return;
        //             // }
        //             if (tempTableData[i].identifiersDetail[j].identifiers.length === (k + 1)) {
        //                 item.identifiersValue.push({
        //                     identifiers: tempTableData[i].identifiersDetail[j].identifiers
        //                 })
        //             }
        //         }
        //     }
        // }
        payload.packageIds.push(item);
      }
      if (tempTableData.length === i + 1) {
        if (payload.packageIds.length > 0) {
          console.log("final payload", payload);
          // return;
          if (props.tenantId) {
            payload.tenantId = props.tenantId;
          }
          setLoading(true);
          BusApiCall(
            "POST",
            `${constants.busV44UrlPublic}/orders/${props.orderId}/packageOrderItems`,
            payload,
          )
            .then((res) => {
              console.log("here is the response", res);
              props.close(true);
            })
            .catch((err) => {
              if (
                err.response &&
                err.response.data &&
                err.response.data.message
              ) {
                setError(err.response.data.message);
                // props.setErrorMessage(err.response.data.message, false)
              } else {
                setError(props.t("DEFAULT_ERROR_MESSAGE"));
                // props.setErrorMessage(props.t('DEFAULT_ERROR_MESSAGE'), false)
              }
            });
        } else {
          setError(props.t("MIN_QUANTITY_ERROR_MSG"));
        }
        payload.packageIds.push(item);
      }
      // if (tempTableData.length === (i + 1)) {
      //     console.log('check payload 2', payload);
      //     setLoading(true);
      //     BusApiCall('POST', `${constants.busV44UrlPublic}/orders/${props.orderId}/packageOrderItems`, payload).then(res => {
      //         console.log('here is the response', res);
      //         props.close(true);
      //     }).catch(err => {
      //         if (err.response && err.response.data && err.response.data.message) {
      //             props.setErrorMessage(err.response.data.message, false)
      //         } else {
      //             props.setErrorMessage(props.t('DEFAULT_ERROR_MESSAGE'), false)
      //         }
      //     })
      // }
    }
  };
  const changeOfferingQuantity = (e, item) => {
    setError("");
    var data = [...tableData];
    var index = data.findIndex((x) => x.packageId === item.packageId);
    if (index > -1) {
      var quantityAvailable = data[index].quantityAvailable;
      var newQuantity = +e.target.value;
      if (+e.target.value > 0) {
        if (newQuantity <= quantityAvailable) {
          item.quantity = e.target.value;
          data[index] = item;
          data[index].expand = true;
          setTableData(data);
        } else {
          setError("Maximum available quantity is " + quantityAvailable);
          item.quantity = "";
          data[index] = item;
          setTableData(data);
        }
      } else {
        if (+e.target.value < 0) {
          item.quantity = "";
          data[index] = item;
          setTableData(data);
        } else {
          item.quantity = e.target.value;
          data[index] = item;
          setTableData(data);
        }
      }
    }
    // //////////////////////////////////////

    return;
    var oldQuantity = jp.query(
      data[index].identifiersDetail,
      "$..[?(@.packageIndex)]",
    ).length;
    var quantityAvailable = data[index].quantityAvailable;
    if (+e.target.value > 0) {
      if (e.target.value <= item.quantityAvailable) {
        item.quantity = e.target.value;
        var newQuantity = +e.target.value;
        if (newQuantity <= quantityAvailable) {
          var actualQauntityToAdd = 0;
          let count = jp.query(
            data[index].identifiersDetail,
            "$..[?(@.new)]",
          ).length;
          if (newQuantity < count) {
            item.identifiersDetail.splice(newQuantity + oldQuantity);
            data[index] = item;
            data[index].expand = true;
            setTableData(data);
            return;
          }
          if (count > 0) {
            actualQauntityToAdd = newQuantity - count;
          } else {
            actualQauntityToAdd = newQuantity;
          }
          for (var q = 0; q < actualQauntityToAdd; q++) {
            var row = [];
            for (var i = 0; i < item.identifiers.length; i++) {
              row.push({
                ...item.identifiers[i],
                value: "",
              });
            }
            item.identifiersDetail.push({
              identifiers: row,
              new: true,
            });
            if (q + 1 === +actualQauntityToAdd) {
              data[index] = item;
              data[index].expand = true;
              setTableData(data);
            }
          }
        } else {
          console.log("check else condition", newQuantity <= quantityAvailable);
        }
      } else {
        setError("Maximum available quantity is " + item.quantityAvailable);
      }
    } else {
      if (+e.target.value < 0) {
        item.quantity = "";
        data[index] = item;
        setTableData(data);
      } else {
        item.quantity = e.target.value;
        data[index] = item;
        setTableData(data);
      }
    }
  };

  const expandOfferingRow = (e, item) => {
    var data = [...tableData];
    var index = data.findIndex((x) => x.packageId === item.packageId);
    if (index > -1) {
      data[index].expand = !data[index].expand;
      setTableData(data);
    }
  };

  const chnageMetaData = (e, item, identifierIndex, column) => {
    setError("");
    var data = [...tableData];
    var index = data.findIndex((x) => x.packageId === item.packageId);
    if (index > -1) {
      var item = data[index];
      var identifierRow = item.identifiersDetail[identifierIndex];
      var identifierColumnIndex = identifierRow.identifiers.findIndex(
        (x) => x.name === e.target.name,
      );
      if (identifierColumnIndex > -1) {
        identifierRow.identifiers[identifierColumnIndex].value = e.target.value;
        item.identifiersDetail[identifierIndex] = identifierRow;
        data[index] = item;
        setTableData(data);
      }
    }
  };

  return (
    <React.Fragment>
      <Dialog
        disableScrollLock={true}
        PaperComponent={DraggableDialogPaper}
        open={props.open}
        maxWidth={"md"}
        fullWidth={true}
      // PaperProps={{
      //     className: classess.resizablePaper
      // }}
      >
        <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
          <div style={{ display: "flex" }}>
            <span style={{ display: "inline-flex", width: "95%" }}>
              {t("PROCESS_ORDER")}
            </span>
            <Tooltip title={t("CLOSE")}>
              <IconButton
                onTouchStart={() => {
                  props.close(false);
                }}
                onClick={() => {
                  props.close(false);
                }}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={3}>
            {tableData
              .sort((a, b) => (a && b ? a.index - b.index : 0))
              .map((item, index) => (
                <React.Fragment key={index}>
                  <div className={classes.partialOrderProcessingContainer}>
                    <div style={{ padding: "1rem" }}>
                      {" "}
                      <b>{item.productName}</b>
                    </div>
                    {/* <TableRow> */}
                    {/* <TableCell>
                                                {item.inProgressItems && item.inProgressItems.length > 0 &&
                                                    <Tooltip title={t('EXPAND')}>
                                                        <IconButton aria-label="expand row" size="small"
                                                            onClick={(event) => {
                                                                expandOfferingRow(event, item);
                                                            }}
                                                        >
                                                            {item.expand ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                        </IconButton>
                                                    </Tooltip>
                                                }
                                            </TableCell> */}
                    {/* <Table className='order_history_child_table'> */}
                    <TableContainer>
                      <Table className="newGlobalTable roundCorners">
                        <TableHead>
                          <TableRow>
                            {/* <TableCell style={{ width: '25px' }}></TableCell> */}
                            {/* <TableCell>{t('OFFERING_NAME')}</TableCell> */}
                            <TableCell align="right" style={{ width: "50px" }}>
                              {t("QUO_ORDERED")}
                            </TableCell>
                            <TableCell align="right" style={{ width: "70px" }}>
                              {t("IN_PROGRESS")}
                            </TableCell>
                            <TableCell align="right" style={{ width: "50px" }}>
                              {t("PENDING")}
                            </TableCell>
                            <TableCell align="right" style={{ width: "50px" }}>
                              {t("COMPLETED")}
                            </TableCell>
                            <TableCell align="right" style={{ width: "100px" }}>
                              {t("FULFILL")}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            {/* <TableCell>{item.productName}</TableCell> */}
                            <TableCell align="right">
                              {item.quantityOrdered}
                            </TableCell>
                            <TableCell align="right">
                              {item.quantityInProgress}
                            </TableCell>
                            <TableCell align="right">
                              {item.quantityAvailable}
                            </TableCell>
                            <TableCell align="right">
                              {item.quantityFulfilled}
                            </TableCell>
                            <TableCell align="right">
                              <Input
                                className={classes.quantityInput}
                                type="number"
                                min="1"
                                step="1"
                                name="quantity"
                                value={item.quantity}
                                onChange={(e) => {
                                  changeOfferingQuantity(e, item);
                                }}
                                style={{ width: "80px" }}
                                disabled={item.quantityAvailable === 0}
                              />
                            </TableCell>
                          </TableRow>
                          {/* <TableRow>
                                            <TableCell style={{ paddingBottom: 0, paddingTop: 0, borderBottom: item.expand ? '' : 'none' }} colSpan={6}>
                                                <Collapse in={true} timeout="auto" unmountOnExit>
                                                    <Table className=''>
                                                        <TableBody>
                                                            {item.identifiersDetail.map((identifierRow, index) =>
                                                                <TableRow key={index}>
                                                                    {identifierRow.identifiers.map((column, colIndex) =>
                                                                        <TableCell key={colIndex}>
                                                                            <Input
                                                                                value={column.value}
                                                                                name={column.name}
                                                                                placeholder={column.label}
                                                                                onChange={(e) => { chnageMetaData(e, item, index, column) }}
                                                                                disabled={identifierRow.packageIndex}
                                                                            />
                                                                        </TableCell>
                                                                    )}
                                                                </TableRow>
                                                            )}
                                                        </TableBody>
                                                    </Table>
                                                </Collapse>
                                            </TableCell>
                                        </TableRow> */}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </React.Fragment>
              ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Box style={{ width: '100%' }}>
            <Grid container spacing={3} style={{ margin: 0 }}>
              <Grid
                item
                style={{ color: "#f44336", fontWeight: "bold" }}
                size={{
                  xs: 8,
                }}
              >
                {error}
              </Grid>
              <Grid
                item
                align="right"
                size={{
                  xs: 4,
                }}
              >
                {/* <Button onClick={() => props.close(false)} style={{ marginLeft: '8px' }}>{t('CANCEL')}</Button> */}
                <Button onClick={() => submitForm()}>{t("SUBMIT")}</Button>
              </Grid>
            </Grid>
          </Box>
        </DialogActions>
      </Dialog>
      <Loader loading={loading} />
    </React.Fragment>
  );
};

const DraggableDialogPaper = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      bounds={"parent"}
      defaultClassName="customReactDraggableComponent"
      handle="#draggableDialogPaper"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(PartialOrderProcessingDialog));
